import type { ABTestCampaignId } from "@/data/abTestCampaigns.data";
import type { AuthStoreState } from "@/stores/useAuth";
import { isStandaloneFlow } from "@/lib/funnelFlow";
import { useAuthStore } from "@/stores/useAuth";

/** The rule behind the hook, for a one-off read off `useAuthStore.getState()`. */
export const isABTestVariant = (
  state: Pick<AuthStoreState, "abTestVariants" | "funnelFlow">,
  campaignId: ABTestCampaignId,
  variantName: string,
) =>
  state.abTestVariants?.[campaignId] === variantName &&
  !isStandaloneFlow(state.funnelFlow);

/**
 * Whether this device is in `variantName` of a campaign. Anything else — flag
 * absent, `off`, a failed fetch, another variant — is the control: the
 * control is the default, so a missing flag can never expose the tested
 * surface. A standalone funnel (exp_wmq) skips the experiment fetch but
 * nothing clears a variant persisted during an earlier default-flow visit,
 * hence the guard. One selector for the two reads: they only ever change
 * together, and `SeriesLink` mounts one per cover.
 */
const useIsABTestVariant = (
  campaignId: ABTestCampaignId,
  variantName: string,
) => useAuthStore((s) => isABTestVariant(s, campaignId, variantName));

export default useIsABTestVariant;
